import { Action } from 'redux';
import { actionTypes as t } from '../actions';

interface TakeoverDetails {
  isOpen: boolean;
  [key: string]: unknown;
}

interface TakeoversState {
  [key: string]: TakeoverDetails;
}

interface TakeoversAction {
  type: string;
  payload: {
    name: string;
    props?: Record<string, unknown>;
  };
}

export const takeoversReducer = (state: TakeoversState = {}, action: Action) => {
  switch (action.type) {
    case t.OPEN_TAKEOVER: {
      const { name, props = {} } = (action as TakeoversAction).payload;
      return {
        ...state,
        [name]: { isOpen: true, ...props },
      };
    }
    case t.CLOSE_TAKEOVER: {
      const { name } = (action as TakeoversAction).payload;
      return Object.entries(state).reduce(
        (acc, [key, value]) => (name === key ? acc : { ...acc, [key]: value }),
        {},
      );
    }
    default:
      return state;
  }
};
